export default "__VITE_ASSET__a223b410__"